export const TOWNS = [
  {
    slug: "galliera",
    name: "Galliera",
    intro: "Il Centro Dentistico Galliera è in Via della Pace 41, a San Venanzio di Galliera: per chi vive in paese le cure parodontali sono a portata di mano, senza dover andare fino in città.",
    note: "Essere vicini a casa conta, soprattutto nel mantenimento: i richiami 3-4 volte l'anno diventano un'abitudine semplice da rispettare.",
  },
  {
    slug: "san-pietro-in-casale",
    name: "San Pietro in Casale",
    intro: "Se vivi a San Pietro in Casale e ti sanguinano le gengive o senti un dente che si muove, puoi rivolgerti al Centro Dentistico Galliera, nel comune vicino, per una prima visita parodontale con il Dott. Nicola Mauro.",
    note: "Il percorso laser può essere concentrato anche in un'unica seduta principale, previa valutazione: meno viaggi, meno attese.",
  },
  {
    slug: "malalbergo",
    name: "Malalbergo",
    intro: "Per chi abita a Malalbergo, Altedo e dintorni, il Centro Dentistico Galliera offre un percorso dedicato alla cura della parodontite con laser e microscopio operatorio, senza bisturi e senza punti.",
    note: "La prima visita parte sempre da una conversazione: ci racconti i tuoi sintomi e le tue paure, poi decidi tu come procedere.",
  },
  {
    slug: "poggio-renatico",
    name: "Poggio Renatico",
    intro: "Anche da Poggio Renatico e dal ferrarese molti pazienti scelgono il Centro Dentistico Galliera per curare la parodontite con un approccio delicato, pensato per chi ha paura del dentista.",
    note: "Con il sondaggio parodontale misuriamo la profondità delle tasche gengivali: dati oggettivi per capire da dove partire e verificare la guarigione.",
  },
  {
    slug: "pieve-di-cento",
    name: "Pieve di Cento",
    intro: "Se vivi a Pieve di Cento o a Cento e cerchi un parodontologo che lavori con il laser, il Centro Dentistico Galliera è un riferimento vicino per diagnosi, terapia e mantenimento.",
    note: "Oltre alla terapia laser, offriamo l'igiene professionale GBT certificata: delicata, adatta anche a impianti e denti sensibili.",
  },
  {
    slug: "bologna",
    name: "Bologna",
    intro: "Molti pazienti da Bologna e provincia scelgono di curare la parodontite al Centro Dentistico Galliera, in un ambiente tranquillo, lontano dal traffico della città, con un percorso costruito sui tempi di chi ha paura.",
    note: "Chi arriva da più lontano apprezza la possibilità, previa valutazione, di svolgere la fase terapeutica principale in un'unica seduta di circa 3 ore.",
  },
  {
    slug: "cento",
    name: "Cento",
    intro: "Da Cento e dall'Alto Ferrarese il Centro Dentistico Galliera è un riferimento vicino per chi cerca un parodontologo che curi la parodontite con il laser, in modo delicato e senza fretta.",
    note: "Gengive che sanguinano e alito cattivo sono spesso i primi segnali: prima si interviene, più osso e più denti naturali si riescono a conservare.",
  },
  {
    slug: "bentivoglio",
    name: "Bentivoglio",
    intro: "Per chi vive a Bentivoglio, San Marino di Bentivoglio e dintorni, il Centro Dentistico Galliera offre un percorso dedicato alla cura della parodontite con laser e microscopio operatorio.",
    note: "Il primo incontro può essere anche solo una conversazione: ci racconti i tuoi sintomi e le tue paure, e decidi tu quando iniziare.",
  },
  {
    slug: "argelato",
    name: "Argelato",
    intro: "Se abiti ad Argelato o a Funo e ti sanguinano le gengive, puoi prenotare una prima visita parodontale con il Dott. Nicola Mauro al Centro Dentistico Galliera, nella pianura a nord di Bologna.",
    note: "Dopo la terapia, il mantenimento 3-4 volte l'anno protegge i risultati: brevi sedute delicate, anche con igiene GBT.",
  },
  {
    slug: "minerbio",
    name: "Minerbio",
    intro: "Da Minerbio e Ca' de Fabbri molti pazienti scelgono il Centro Dentistico Galliera per curare la parodontite senza bisturi e senza punti, con un approccio pensato per chi ha paura del dentista.",
    note: "Con il sondaggio parodontale misuriamo ogni tasca gengivale: numeri chiari per capire da dove partire e verificare la guarigione nel tempo.",
  },
  {
    slug: "baricella",
    name: "Baricella",
    intro: "Per chi vive a Baricella e nei paesi vicini, il Centro Dentistico Galliera è un punto di riferimento per diagnosi, terapia laser e mantenimento della parodontite.",
    note: "Il laser a tre lunghezze d'onda aiuta a decontaminare le tasche e a ridurre l'infiammazione, mentre il tartaro sotto gengiva si rimuove con precisione al microscopio.",
  },
  {
    slug: "castel-maggiore",
    name: "Castel Maggiore",
    intro: "Se vivi a Castel Maggiore o a Trebbo di Reno e cerchi un parodontologo che lavori con il laser, al Centro Dentistico Galliera trovi un ambiente tranquillo e un percorso costruito sui tuoi tempi.",
    note: "Non sai se le tue gengive sono a rischio? Il test online di un minuto ti dà una prima indicazione, poi una visita chiarisce tutto con calma.",
  },
];

export const townBySlug = (slug) => TOWNS.find((t) => t.slug === slug);
